import {atom} from 'recoil';

import {IReasonRejectionsDict} from '../../shared/types/reasonRejectionsDict.types';
import {IPageableDto} from '../../shared/types/pageable.types';
import {getEmptyPage} from '../../shared/helpers/getEmptyPage';

export const reasonRejectionsDictQueryTrigger = atom<number>({
  key: 'reasonRejectionsDictQueryTrigger',
  default: 0,
});

export const reasonRejectionsDictQueryByCodeTrigger = atom<number>({
  key: 'reasonRejectionsDictQueryByCodeTrigger',
  default: 0,
});

export const reasonRejectionsState = atom<IPageableDto<IReasonRejectionsDict>>({
  key: 'reasonRejectionsState',
  default: getEmptyPage<IReasonRejectionsDict>(),
});

export const currentreasonRejectionState = atom<IReasonRejectionsDict | null>({
  key: 'currentreasonRejectionState',
  default: null,
});

export const currentreasonRejectionCodeState = atom<string | null>({
  key: 'currentreasonRejectionCodeState',
  default: null,
});

export const reasonRejectionsMapWithNamesState = atom<Map<string, string>>({
  key: 'reasonRejectionsMapWithNamesState',
  default: new Map<string, string>(),
});
